import { EulerPortfolioContainer } from '@/features/euler-portfolio/EulerPortfolioContainer'

export function LendBorrowDashboard() {
  return <EulerPortfolioContainer />
}

